import { useEffect } from 'preact/hooks';

// TODO: TONCONNECT. Remove patch when package works with preact
import { TonConnectUIProvider } from '@tonconnect/ui-react/packages/ui-react/lib/index.cjs';
import WebApp from '@twa-dev/sdk';

import { useWrapperAdsActions } from '@/entities/ad-banner/model/wrapper-ads.store';
import {
  usePlaydeckActions,
  usePlaydeckOpen,
} from '@/entities/playdeck/models/playdeck.store';

import { getDecodedStartappQuery } from '@/shared/helpers/telegram/get-decoded-startapp-query';
import { getUrlParams } from '@/shared/helpers/telegram/get-url-params';
import { makeTwaReturnLink } from '@/shared/helpers/telegram/make-twa-return-link';
import { useWs } from '@/shared/hooks/use-ws';
import { useMining } from '@/shared/hooks/use-ws/use-mining';
import { useSubscribeToWallet } from '@/shared/hooks/use-ws/use-subscribe-to-wallet';
import { AnalyticsService } from '@/shared/service/analytics/analytics-service';
import { useAppState, usePdTma } from '@/shared/stores/app-store/app-store';

import { TON_CONNECT_MANIFEST_URL } from '../constants';
import { withErrorBoundary } from '../hocs/withErrorBoundary';
import { useFightScore } from '../hooks/use-fight-scrore-ws';
import { useScreenTimeTracking } from '../hooks/use-screen-tracking';
import { App } from './App';

export const AppWrapper = withErrorBoundary(() => {
  const ws = useWs();

  const { startAppArgs, game, lang } = useAppState();
  const pdTma = usePdTma();

  const { fetchAds } = useWrapperAdsActions();
  const { setHideUI } = usePlaydeckActions();

  const pdOpen = usePlaydeckOpen();

  useSubscribeToWallet(ws);
  useMining(ws, !game || pdOpen);
  useFightScore(ws, game);
  useScreenTimeTracking();

  useEffect(() => {
    const { hideUI } = getUrlParams();
    const startappQuery = getDecodedStartappQuery();

    // Инициализируем hideUI в самом начале
    if (startappQuery?.pdHideUI) {
      // из startappQuery параметров
      setHideUI(startappQuery?.pdHideUI);
    } else if (hideUI) {
      // или URL параметров
      setHideUI(hideUI);
    }

    fetchAds();

    AnalyticsService.init({
      startAppArgs,
      startAppRaw: WebApp.initDataUnsafe.start_param,
      ws,
      pdTma,
    });

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <TonConnectUIProvider
      manifestUrl={TON_CONNECT_MANIFEST_URL}
      actionsConfiguration={{
        twaReturnUrl: makeTwaReturnLink(game?.key),
      }}
      language={lang}
    >
      <App />
    </TonConnectUIProvider>
  );
});
